/**
 * @author: liaojianming
 * @date 2019-02-18
 * @description: helper.js 帮助类js
*/

import {initAuthorMenuMixin} from '@/util/mixin';
import dayjs from 'dayjs';
import Author from '@/util/author'
import util from '@/libs/util'
import Sessionstorage from '@/util/sessionstorage'

export default {
    // YYYY-MM-DD HH:mm:ss
    time: function(time) {
        return dayjs(time).format('YYYY-MM-DD HH:mm:ss');
    },
    // YYYY-MM-DD
    shortTime: function(time) {
        return dayjs(time).format('YYYY-MM-DD');
    },
    // HH:mm:ss
    clockTime: function(time) {
        return dayjs(time).format('HH:mm:ss');
    },
    // YYYY-MM
    monthTime: function(time) {
        return dayjs(time).format('YYYY-MM');
    },
    trim(str){
        if(!str){
            return '';
        }else{
            return str.replace(/(^\s*)|(\s*$)/g, "");
        }
    },
    //判断闰年
    isLeapYear: function(year) {
        const cond = year % 4 == 0 && year % 100 != 0 || year % 400 ==0;
        if(cond) {
            return 1;
        } else {
            return 0;
        }
    },
    //年 月 日
    getDateInfo: function(){
        let date = new Date();
        let dateStamp = date.getTime()
        let y = date.getFullYear();    
        let m = date.getMonth()+1;    
        let d = date.getDate(); 
        return {
            y,
            m,
            d,
            dateStamp: date,
        } 
    },
    get_stamp_today_zeroTime(){
        const currentStamp = (this.getDateInfo()).dateStamp;
        //YYYY-MM-DD
        const today_yyyymmdd = this.shortTime(currentStamp);

        //当天00:00:00
        const today_zeroTime = (new Date(today_yyyymmdd + ' 00:00:00')).getTime();
        return today_zeroTime+'';
    },
    get_stamp_oneMonthAfter_twelveTime(){
        const dateInfo = this.getDateInfo();
        const year = dateInfo.y;
        const month = dateInfo.m;
        //当前日期
        const day = dateInfo.d;
        //一个月后
        var month_afterOneMonth = month + 1;
        var day_afterOneMonth = day - 1;
        month_afterOneMonth = month_afterOneMonth < 10 ? ('0' + month_afterOneMonth) : month_afterOneMonth;
        day_afterOneMonth = day_afterOneMonth < 10 ? ('0' + day_afterOneMonth) : day_afterOneMonth;
        const oneMonthAfter_yyyymmdd = year+'-'+month_afterOneMonth+'-'+day_afterOneMonth;

        //一个月后23:59:59
        const oneMonthAfter_twelveTime = (new Date(oneMonthAfter_yyyymmdd + ' 23:59:59')).getTime();
        return oneMonthAfter_twelveTime+'';
    },
    // 是否有权限  返回true/false
    async ishavePermissions(authorCode) {
        if (await this.isAdmin()) {
           return  Promise.resolve(true)
        }
        let systemMenuPermissionsRootList = await this.fetchSystemMenuPermissionsRootList()
        let obj = this.findAuthorCode(systemMenuPermissionsRootList, authorCode)
        return Promise.resolve(obj && obj.available)  
    },
    // 获取权限的systemMenuPermissionsRootList
    async fetchSystemMenuPermissionsRootList() {
        let systemMenuPermissionsRootList = Sessionstorage.getMenuRootlist();
        if (systemMenuPermissionsRootList) {
            return Promise.resolve(systemMenuPermissionsRootList)
        }
        
        systemMenuPermissionsRootList = await initAuthorMenuMixin.methods.getMenuList()
        return  Promise.resolve(systemMenuPermissionsRootList)
    },
    // 获取去权限的SystemMenuPermissionId   一般用来查询权限下的属性
    async getSystemMenuPermissionId(authorCode) {
        let systemMenuPermissionsRootList = await this.fetchSystemMenuPermissionsRootList()
        let obj = this.findAuthorCode(systemMenuPermissionsRootList, authorCode)
        return Promise.resolve(obj && obj.systemMenuPermissionId)
    },
    // 查找是否有权限字符串  有则返回所在的对象
    findAuthorCode (list, authorCode) {
        let obj = null 
        function func (list, authorCode) {
            return list.some((item, index) => {
                if (item.permissions === authorCode) {
                    obj = item
                    return true
                }
                if (item.children.length) {
                    return func(item.children, authorCode)
                }
                return false
            })
        }
        func(list, authorCode)
        return obj
    },
    // 获取systemRoles
    async fetchSystemRoles() {
        let systemRolesList = Sessionstorage.getSystemRoles();
        if (systemRolesList) {
            return Promise.resolve(systemRolesList)
        }

        systemRolesList = await initAuthorMenuMixin.methods.getMenuList('systemRoles')
        return  Promise.resolve(systemRolesList)
    },
    // 是否是超级管理员
    async isAdmin() {
        let systemRolesList =  await this.fetchSystemRoles()
        let flag = systemRolesList.some(item => {
            return item.systemRoleId === '1' && item.checked
        })
        return flag
    },
    setBtnPropertyLoading (list, key, option) {
        list.forEach(n=> {
            if (n.key === key) {
                for (let child in option ) {
                    n[child] = option[child]
                }
            }
        })
    }
}